import "./style.scss";
import * as React from "react";

const Row = (props: RowProps): any => {
  const { className: className = "", id } = props;
  return (
    <div className={"row " + className} id={id}>
      {props.children}
    </div>
  );
};

interface RowProps {
  className?: string;
  id: string;
  children: any;
}

export default Row;



// WEBPACK FOOTER //
// ./client/modules/core/Row/index.tsx